<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center row wrap>
      <v-flex xs12 md6 lg6>
        <div class="text-start pa-2">
          <p v-html="target.complete_description"></p>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Target } from '@/model/models'

export default {
  name: 'Complete',
  props: {
    sheetId: String
  },
  computed: {
    to () {
      return `/surveys/${this.sheetId}/`
    },
    target () {
      return Target.query().first()
    },
    gaTrackingId () {
      return this.target['ga_tracking_id']
    }
  },
  created () {
    gtag('config', this.gaTrackingId, { 'page_path': this.$route.path })
  }
}
</script>

<style scoped>

</style>
